<template>
  <div v-if="isShowStatus || activeChat">
    <div v-if="!isOnline">{{ $t('chat.waitingForNetwork') }}</div>
    <div v-else-if="!isWsOpened">{{ $t('chat.connecting') }}...</div>
    <template v-else>
      <div :class="$style.avatarWrap">
        <ChatAvatar
          :chat="activeChat"
          :class="$style.avatar"
          :receiver="receiver"
          :size="40"
          @click.native="showProfile"
        />
        <div :class="$style.providerIcon">
          <img :class="$style.providerIconImg" :src="$options.providersIcons['default']" alt="" />
        </div>
      </div>
      <div @click="showProfile" :class="$style.title" :title="activeChatTitle">{{ activeChatTitle }}</div>
      <div :class="$style.info">{{ activeChatInfo }}</div>
      <div v-if="isShowActions" :class="$style.actions">
        <!-- <div :class="$style.actionsButton">
          <BaseIcon name="search" @click="searchInChat" />
        </div> -->
        <v-popover placement="bottom-end" popoverClass="no-arrow">
          <div :class="$style.actionsButton">
            <BaseIcon custom name="ellipsisX" :class="['tooltip-target']" />
          </div>
          <ChatMenu :chat="activeChat" slot="popover" />
        </v-popover>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChatMenu from './ChatMenu'
import ChatAvatar from './ChatAvatar'
import { parseRouterQueryParam } from '@/helpers/index'

const providersIcons = {
  whatsapp: require('@/assets/icons/png/whatsapp-ico.png'),
  telegram: require('@/assets/icons/png/telegram-ico.png'),
  default: require('@/assets/icons/png/hola-ico.png')
}

export default {
  name: 'chat-info-header',
  providersIcons,
  components: {
    ChatMenu,
    ChatAvatar
  },
  computed: {
    ...mapGetters({
      isOnline: 'isOnline',
      isWsOpened: 'ws/isOpened',
      user: 'auth/user',
      chatById: 'entities/chats/getById',
      userById: 'entities/users/find'
    }),
    activeChatId () {
      return parseRouterQueryParam(this.$route.query.id, true)
    },
    activeChat () {
      return this.chatById(this.activeChatId)
    },
    receiver () {
      return this.activeChat.participantsUsers.find(user => user && user.userId !== this.user.id)
    },
    activeChatTitle () {
      if (!this.activeChat) return
      if (this.activeChat.type === 2) {
        return this.receiver && this.receiver.displayName
      }
      return this.activeChat.name
    },
    activeChatInfo () {
      if (!this.activeChat) return
      if (this.activeChat.typeName === 'one-to-one') {
        if (this.activeChat.isTyping) {
          return this.$t('chat.typing')
        }
        if (this.receiver?.isOnline) {
          return this.$t('chat.online')
        }
      }
      if (this.activeChat.typeName === 'group') {
        const onlineCount = this.activeChat.participantsUsers.filter(user => user.isOnline).length
        const n = this.activeChat.participants.length
        const usersCountString = `${n} ${this.$tc('chat.users', n)}`
        return onlineCount ? `${usersCountString} | ${onlineCount} ${this.$t('chat.online')}` : usersCountString
      } else {
        return ''
      }
    },
    isShowStatus () {
      return !this.isOnline || !this.isWsOpened
    },
    isShowActions () {
      return this.activeChat
    }
  },
  methods: {
    showProfile () {
      if (this.activeChat.type === 1) {
        this.$modal.show('group-profile', {
          chatId: this.activeChatId
        })
      } else if (this.activeChat.type === 2) {
        this.$modal.show('profile', {
          userId: this.receiver.userId,
          chatId: this.activeChatId
        })
      }
    },
    searchInChat () {
      // this.isSearchInChat = true
      // this.searchQuery = ''
      // this.$refs.search.focus()
      this.$emit('search-in-chat')
    }
  }
}
</script>

<style module lang="scss">
.avatar {
  flex-shrink: 0;
}
.avatar,
.title {
  cursor: pointer;
}
.title {
  font-size: 16px;
  margin-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.info {
  flex-grow: 1;
  margin-left: 28px;
  font-weight: 300;
  flex-shrink: 0;
}
.actions {
  display: flex;
  font-size: 20px;
  &Button {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 48px;
    margin-left: 10px;
    color: $text-mid-dark;
    &:hover {
      color: $text-colored;
    }
  }
}
.avatarWrap {
  display: flex;
  align-items: center;
  flex-grow: 0;
  position: relative;
}

.providerIconImg {
  display: block;
  width: 18px;
  height: 18px;
  position: absolute;
  z-index: 2;
  left: -9px;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  padding: 1px;
  border-radius: 50%;
}
</style>
